import { cn } from '@/shared/lib/utils'

const SIZES = {
  sm: 'h-6 w-6',   // 24px
  md: 'h-8 w-8',   // 32px
  lg: 'h-10 w-10', // 40px
} as const

interface NicolAIAvatarProps {
  size?: keyof typeof SIZES
  className?: string
}

/**
 * NicolAI avatar component for consistent branding across all chats
 * Uses avatar-nicolai.png with standardized sizes
 */
export function NicolAIAvatar({ size = 'md', className }: NicolAIAvatarProps) {
  return (
    <img
      src="/avatar-nicolai.png"
      alt="NicolAI"
      className={cn('shrink-0 rounded-full', SIZES[size], className)}
    />
  )
}
